import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  noImage: {
    id: 'Avatar.noImage',
    description: 'No image text',
    defaultMessage: 'Ladda upp',
  },
});
